import { defineStore } from 'pinia'
import API from '../api/axios'

function safeParse(key: string, fallback: any = []) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback // null, empty string
    return JSON.parse(raw)
  } catch (e) {
    console.warn(`Invalid JSON in localStorage for key "${key}"`, e)
    return fallback
  }
}

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      language: 'gb',
      isSidebarMinimized: false,
      resources: safeParse('resources', []),
      userName: '',
      lastModLists: safeParse('lastModLists', {}),
      sources: safeParse('sources', []),
      categories: safeParse('categories', []), //check if there is a category set at local storage and has json format, if not set it to empty
    }
  },
  getters: {},
  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    async miscGetResources() {
      if (localStorage.getItem('resources')) return true
      try {
        const resp = await API.get('/v1/users/getresources')
        console.log('resources:', resp)
        this.resources = resp.data.resources
        localStorage.setItem('resources', JSON.stringify(this.resources))
        return true
      } catch (err: any) {
        console.error('ERROR ', err.message)
        return { Error: err.message }
      }
    },
    changeUserName(userName: string) {
      this.userName = userName
    },
    async getLastMods() {
      const lstor = localStorage.getItem('lastModLists')
      const lastm = lstor == undefined ? {} : JSON.parse(lstor)
      const lresp = await API.get('/v1/general/lastmod')
      for (let i = 0; i < lresp.data.lastmod.length; i++) {
        const checky = lresp.data.lastmod[i].L_LASTMOD
        const checkt = lresp.data.lastmod[i].L_TABLE
        if (lastm[checkt] == undefined) lastm[checkt] = { laststored: 0 }
        lastm[checkt].lastmod = checky
      }
      this.lastModLists = lastm
      localStorage.setItem('lastModLists', JSON.stringify(this.lastModLists))
      return true
    },
    async setLastMod(table: string) {
      this.lastModLists[table].laststored = this.lastModLists[table].lastmod //Math.floor(Date.now() / 1000);
      localStorage.setItem('lastModLists', JSON.stringify(this.lastModLists))
      return true
    },
    async getSourceShortlist(force: boolean) {
      if (localStorage.getItem('sources') && force == false) {
        return true
      }

      try {
        const sresp = await API.get('/v1/sources/shortlist')
        this.sources = sresp.data.sources
        localStorage.setItem('sources', JSON.stringify(this.sources))
        return true
      } catch (err: any) {
        console.error('ERROR getsourceshortlist ', err.message)
        return { Error: err.message }
      }
    },

    async getCategoriesShortlist(force: boolean) {
      if (localStorage.getItem('categories') && force == false) {
        return true
      }

      try {
        const sresp = await API.get('/v1/categories/shortlist')
        this.categories = sresp.data.categories
        localStorage.setItem('categories', JSON.stringify(this.categories))
        return true
      } catch (err: any) {
        console.error('ERROR getcategorieshortlist ', err.message)
        return { Error: err.message }
      }
    },
  },
})
